"use client";

import { useRouter } from "next/navigation";
import { FunctionComponent, useEffect } from "react";
import { PATHS } from "rivals/shared/constants";
import { checkLoginTimestampCookie } from "rivals/shared/utils/auth";
import { Props } from "./types";

/**
 * Checks the cookie to determine if the user is authenticated in the last 2 hours
 * Pages wrapped with this component require strict authentication to visit
 * If the user is not strictly authenticated, they should be redirected to the Strict Sign In page
 */
const StrictlyProtectedPage: FunctionComponent<Props> = ({
  children
}: Props) => {
  const loginTimestampValid = checkLoginTimestampCookie();
  const router = useRouter();
  useEffect(() => {
    if (loginTimestampValid) {
      return;
    }
    router.push(PATHS.STRICT_SIGN_IN);
  }, [loginTimestampValid, router]);

  return <>{children}</>;
};

export default StrictlyProtectedPage;
